import { ColumnActionsMode, IDetailsColumnStyles } from '@fluentui/react';
import { ColumnData } from 'common/components/SearchBar';
import { commonColumnProps } from 'common/utils/columnUtilities';

const colHeaderLeftAlignStyle: Partial<IDetailsColumnStyles> = {
  cellTitle: {
    paddingLeft: 25,
  },
};

export const getColumns = () => {
  const columns: ColumnData[] = [
    {
      key: 'name',
      name: 'Policy',
      fieldName: 'name',
      minWidth: 300,
      maxWidth: 300,
      styles: colHeaderLeftAlignStyle,
      ...commonColumnProps,
    },
    {
      key: 'description',
      name: 'Description',
      fieldName: 'description',
      minWidth: 300,
      maxWidth: 300,
      ...commonColumnProps,
    },
    {
      key: 'action',
      name: '',
      fieldName: 'action',
      minWidth: 50,
      columnActionsMode: ColumnActionsMode.disabled,
      ...commonColumnProps,
      isResizable: false,
    },
  ];
  return columns;
};
